import { Paper, Typography } from '@mui/material';
import { withDefault } from '@weft/utils';
import React from 'react';
import { useArAgingReport } from '../../../../hooks/requests/use-ar-aging-report';
import { ArAgingReportTable } from '../../../reports/reports-page/reports-page-components/ar-aging-report-section/ArAgingReportTable';

export const HomePageBillingCohortSection: React.FC = () => {
  const { data: arAgingReport, isLoading: isLoadingArAgingReport } = useArAgingReport();
  const summary = withDefault(arAgingReport?.summary, []);

  return (
    <Paper
      variant='outlined'
      sx={(theme) => ({
        boxShadow: theme.shadows[1],
        padding: '24px 0',
        height: '400px',
      })}
    >
      <Typography
        variant='h6'
        paddingLeft={3}
      >
        Billing Summary
      </Typography>

      <ArAgingReportTable
        items={summary}
        itemsCount={summary.length}
        loadingItems={isLoadingArAgingReport}
        showPagination={false}
        hideFooter={false}
      />
    </Paper>
  );
};